<template>
  <a
    class="user-tooltip"
    target="_blank"
    @click="openHelpPopUp('data.html')"
  >
    <img
      :src="`${userCommonImageUrlForSp}/tooltip_help_sp.png`"
      alt="データの説明"
      width="25"
      height="25"
    >
  </a>
</template>

<style scoped lang="scss">
@use "@/styles/preview/sp/offer/base" as *;
</style>

<script>
import jobPreviewCommon from '@/lib/jobPreviewCommon'
export default {
  mixins: [jobPreviewCommon]
}
</script>
